import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import {
  CLOSED_CARD_HEIGHT,
  DEFAULT_CLOSED_CARD_WIDTH,
} from "../ExpandableCard/ExpandableCard.css";

export const containerStyle = style({
  vars: {
    "--carousel-child-width": rem(DEFAULT_CLOSED_CARD_WIDTH),
  },
});

export const contentStyle = style({
  minHeight: rem(CLOSED_CARD_HEIGHT),
  height: rem(CLOSED_CARD_HEIGHT),
  containerName: "container",
  containerType: "inline-size",
  padding: theme.spacings.m,
});
